import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_107: FaireProductEntity = {
  token: "legacy_prod_abbott-107",
  type: "product",
  name: 'Mini Low Pumpkin Planter 4" W',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/df614281b4691b3ff8e106aee15be2d8f0dfcac24bfbc087adca45526c14c850.jpeg",
  priceDollars: 16,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
